import { render, staticRenderFns } from "./strippay copy 2.vue?vue&type=template&id=2b2a1b12&scoped=true"
import script from "./strippay copy 2.vue?vue&type=script&lang=js"
export * from "./strippay copy 2.vue?vue&type=script&lang=js"
import style0 from "./strippay copy 2.vue?vue&type=style&index=0&id=2b2a1b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a1b12",
  null
  
)

export default component.exports